export default "__VITE_ASSET__DfdkpwFk__"